var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuthorized)?_c('div',{on:{"click":_vm.openBoosterModal}},[_vm._v("\n  🦍\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }